import Vue from 'vue';
import Vuex from 'vuex';
import userStore from './userStore/userStore';
import invoiceEcommerce from './invoiceEcommerceStore/invoiceEcommerce';
import tableIndexStore from './tableIndexStore/tableIndexStore';
import modalStore from './modalStore/modalStore';
import clearCheckboxStore from './clearCheckboxStore/clearCheckboxStore';
import modalCommentsStore from './modalCommentStore/modalCommentStore';
import refreshStore from './refreshStore/refreshStore';
import invoiceRegisterRefresh from './invoiceRegisterRefresh/invoiceRegisterRefresh';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: userStore,
    invoiceEcommerce,
    tableIndexStore,
    modalStore,
    clearCheckboxStore,
    modalCommentsStore,
    refreshStore,
    invoiceRegisterRefresh,
  },
});
